import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { styled } from '@mui/material/styles';
import { SingleLineText } from '@bloomays-lib/ui.shared';

/** Liste temporaire pour le preview System sur staging — à retirer avec le dashboard C-level. */
const TAM_PREVIEW_LABEL = 'Afficher les primes de';
const TAM_SELECT_PLACEHOLDER = 'Sélectionner un TAM';
const STAGING_TAM_EMAILS = [
  'auriane.de-lencquesaing@bloomays.com',
  'julie.le-dreff@bloomays.com',
  'alix.gastou@bloomays.com',
  'florine.biervoye@bloomays.com',
  'romain.nalais@bloomays.com',
  'lallie.bouchain@bloomays.com',
  'johan.moscardo@bloomays.com',
  'taoues.imakhlaf@bloomays.com',
  'laurelenn.hazard@bloomays.com',
  'joan.ortega@bloomays.com',
  'joris.mansion@bloomays.com',
  'rodolphe.habegger@bloomays.com',
  'loic.calvy@bloomays.com',
] as const;

export type MonthlyPrimeTamSelectProps = {
  selectedTamEmail: string;
  onTamChange: (tamEmail: string) => void;
};

const MonthlyPrimeTamSelect = ({ selectedTamEmail, onTamChange }: MonthlyPrimeTamSelectProps) => {
  return (
    <SelectContainer>
      <PreviewLabel text={TAM_PREVIEW_LABEL} variant="body1Regular" />
      <TamFormControl>
        <TamSelect
          value={selectedTamEmail}
          displayEmpty
          renderValue={(value: string) => value || TAM_SELECT_PLACEHOLDER}
          onChange={(event: SelectChangeEvent<string>) => onTamChange(event.target.value)}
          MenuProps={{
            PaperProps: {
              sx: { minWidth: TAM_SELECT_MIN_WIDTH },
            },
          }}
        >
          {STAGING_TAM_EMAILS.map((email) => (
            <TamMenuItem key={email} value={email}>
              {email}
            </TamMenuItem>
          ))}
        </TamSelect>
      </TamFormControl>
    </SelectContainer>
  );
};

export default MonthlyPrimeTamSelect;

const SelectContainer = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(3),
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

const PreviewLabel = styled(SingleLineText)(({ theme }) => ({
  color: theme.palette.neutral.black,
  whiteSpace: 'nowrap',
}));

const TAM_SELECT_MIN_WIDTH = '400px';

const TamFormControl = styled(FormControl)(() => ({
  minWidth: TAM_SELECT_MIN_WIDTH,
  maxWidth: '100%',
}));

const TamSelect = styled(Select)(() => ({
  minWidth: TAM_SELECT_MIN_WIDTH,
  '& .MuiSelect-select': {
    whiteSpace: 'nowrap',
  },
}));

const TamMenuItem = styled(MenuItem)(() => ({
  whiteSpace: 'nowrap',
}));
